import * as React from "react";

export const PiletLoader = () => <div className="pilet-loader" role="status">Loading...</div>;